import { APP_SERVER_API, CORE_API } from "../constants";
import { getData, postData } from "./common.service";

class CropSerivce {
  private static readonly baseUrl = "/crops";

  static getCropImage = (): Promise<Array<TCrop>> => {
    const url = this.baseUrl;

    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static getCropVariety = (cropId: string): Promise<Array<TCropVariety>> => {
    const url = `${this.baseUrl}/${cropId}/crop-varieties`;

    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static startNewSeason = (payload: TNewCropSeasonPayload): Promise<Array<TNewSeason>> =>{
    const url =  "/cropssown/registerCropSownExistingUser";
    return postData(url, {
      basePath: APP_SERVER_API,
      sendTokenInUrl: true,
      body: payload
    });
  };

}

export default CropSerivce;

export type TCrop = {
    id: string;
    name: string;
    image: string;
    earlyIrrigationThreshold: number
};

export type TCropVariety = {
    displayName: string,
    id: string,
    name: string,
    cropId: string,
    cropName: string
}

export type TCropVarietyOption = {
    displayName: string,
    id: number,
    name: string,
    cropId: string,
    cropName: string,
    varietyId: string
}

export type TNewCropSeasonPayload = {
    plotId: string,
    sowingDate: Date,
    cropId: string,
    crop: string,
    varietyId?: string,
}

export type TNewSeason = {
    activeStage: string,
    created_date: string
    cropId: string,
    cropSownId: string,
    cropStageIds?: string[],
    isCropEnded: boolean, 
    name: string, 
    plotId: string, 
    sowingDate: string, 
    stageStartDate?: string[], 
    stageUpdated: boolean,
    varietyId?: string
}


